import PalmettoSideMenuComponent from './PalmettoSideMenu';
export default PalmettoSideMenuComponent;
